import {CompetitorCount} from "./competitor-count";
import {Organiser} from "./organizer";
import {RacePaymentInfo} from "./race-payment-info";
import {ApplicationFormSettings} from "./race-registration-form-settings";
import {RaceScoring} from "./race-scoring";
import {RaceSettings} from "./race-settings";
import {RaceStartItem} from "./measurement/race-start-item";
import {Competitor} from "./competitor";
import {Waypoint} from "./waypoint";

export class Race {
  static BACKYARD_ULTRA = 3;

  id?: number;
  organiserId?: number;
  organiser?: Organiser;
  name?: string;
  nameEng?: string;
  nameIta?: string;
  nameSlo?: string;
  nameSr?: string;
  nameBs?: string;
  leagueName?: string;
  leagueNameEn?: string;
  leagueNameIt?: string;
  leagueNameSl?: string;
  leagueNameSr?: string;
  leagueNameBs?: string;
  status?: number;
  registrationStart?: Date;
  registrationEnd?: Date;
  raceStart?: Date;
  raceEnd?: Date;
  maxParticipants?: number;
  startEvery?: number;
  length?: number;
  ascent?: number;
  descent?: number;
  image?: string;
  imageIcon?: string;
  imageMini?: string;
  imageSmall?: string;
  imageMedium?: string;
  eventId?: number;
  ageGroupId?: number;
  config?: string;
  created?: Date;
  modified?: Date;
  competitorCount?: CompetitorCount;
  open?: boolean;
  organiserOpen?: boolean;
  competitorId?: number;
  paymentInfo?: RacePaymentInfo;
  favorite?: boolean;
  round?: number;
  registrationType?: number;
  sport?: number;
  virtualRace?: boolean;
  maxAltitude?: number;
  minAltitude?: number;
  shortDescription?: string;
  shortDescriptionEng?: string;
  shortDescriptionIta?: string;
  shortDescriptionSlo?: string;
  shortDescriptionSr?: string;
  shortDescriptionBs?: string;
  registrationMessage?: string;
  registrationMessageEng?: string;
  registrationMessageIta?: string;
  registrationMessageSlo?: string;
  registrationMessageSr?: string;
  registrationMessageBs?: string;
  refreshmentCheckpointAmount?: number;
  raceScoring?: RaceScoring;
  raceSettings?: RaceSettings;
  applicationFormSettings?: ApplicationFormSettings;
  discountApplied?: boolean;
  startCountry?: number;
  startCity?: string;
  raceStartItems?: RaceStartItem[];
  competitors?: Competitor[];
  waypoints?: Waypoint[];

  static isChronometerRace = (startEvery: number|undefined|string): boolean =>
    startEvery !== undefined && startEvery !== "0" && startEvery !== 0;

  static isBackyardUltra = (sport?: number): boolean =>
    sport !== undefined && sport === Race.BACKYARD_ULTRA;
}
